import { render, staticRenderFns } from "./shipDetail.vue?vue&type=template&id=10432e30&scoped=true&"
import script from "./shipDetail.vue?vue&type=script&lang=js&"
export * from "./shipDetail.vue?vue&type=script&lang=js&"
import style0 from "./shipDetail.vue?vue&type=style&index=0&id=10432e30&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10432e30",
  null
  
)

export default component.exports